// FILECONTENT_START src/common/components/PageHeader/index.ts
import PageHeader from "./PageHeader";
export default PageHeader;
export type { PageHeaderProps } from "./PageHeader";
export { default as PageHeaderBreadcrumbs } from "./PageHeaderBreadcrumbs";
export type { PageHeaderBreadcrumbsProps } from "./PageHeaderBreadcrumbs";

// FILECONTENT_END src/common/components/PageHeader/index.ts